export default __webpack_public_path__ + "static/media/IMG_4569-min.a7ae4571.JPG";